import { useQuizStore } from "../../hooks";

export const QuizTerms = () => {
  const { termsAccepted, setTermsAccepted } = useQuizStore();

  return (
    <div className="card">
      <div className="card-body">
        <div className="vstack gap-2">
          <h3 className="mb-0">Protección de datos</h3>
          <div className="mb-0">
            <p className="mb-1">
              La información que nos proporcionas en este formulario es
              confidencial. La utilizaremos exclusivamente para:
            </p>
            <ul className="mb-0 ps-3">
              <li>Evaluar tu historial médico y riesgos de salud.</li>
              <li>Coordinar el tratamiento o procedimiento médico.</li>
              <li>Cumplir con las regulaciones de salud y seguridad.</li>
            </ul>
          </div>
          <p className="mb-0">
            Tu información se almacena de forma segura y no será compartida con
            terceros sin tu consentimiento.
          </p>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="termsAccepted"
              checked={termsAccepted}
              onChange={(e) => setTermsAccepted(e.target.checked)}
            />
            <label
              className="form-check-label mb-0 fw-normal"
              htmlFor="termsAccepted"
            >
              Entiendo cómo se usarán mis datos y doy mi consentimiento para el
              tratamiento de mi información personal y de salud.
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};